import landingCarousel from './carousel.js';

const landingPage = {
    init: function () {
        const videoComponents = document.querySelectorAll('.media-component .video-wrapper');

        landingCarousel.init();

        if (videoComponents) {
            import('../contentful/mediaVideo.js').then(({default: mediaVideo}) => mediaVideo.init(videoComponents));
        }
    }
};

export default landingPage;
